module.exports = "https://cdn-b2c.dom.ru/b2c-domru/2.357.4/frontend/_next/static/images/entrance-4eced2df29a16cf04ac2289bc129a06e.png";